<template>
    <b-modal :active.sync="modalOpen" :can-cancel="false" aria-modal :width="600" scroll="keep">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ method == 'lost' ? 'Tag verloren' : method == 'found' ? 'Tag teruggevonden' : 'Tag verwijderen' }}</p>
        </header>
        <section class="modal-card-body" style="border-radius:0;">
            <p v-if="method == 'lost'">Weet je zeker dat je de tag als verloren wilt registreren?</p>
            <p v-if="method == 'found'">Weet je zeker dat je de tag als (terug) gevonden wilt registreren?</p>
            <p v-if="method == 'remove'">Weet je zeker dat je de tag wilt verwijderen uit deze autorisatie?</p>
        </section>
        <footer class="modal-card-foot text-right">
            <button class="button" type="button" @click="openModal()" :disabled="loading">Annuleren</button>
            <button class="button" :class="{ 'is-primary': method == 'lost', 'is-success': method == 'found', 'is-danger': method == 'remove' }" @click="confirm" :disabled="loading">{{ method == 'remove' ? 'Verwijderen' : 'Bevestigen' }}</button>
        </footer>
    </b-modal>
</template>

<script>
import toastMixins from '@/mixins/toastMixins.js'

export default {
    name: 'ConnectionEditTag',

    props: {
        organisationId: {
            type: Number,
            required: false,
            default: null
        },

        editingDroplet: {
            type: Number,
            required: false,
            default: 0
        },

        record: {
            type: Object,
            required: false
        }
    },

    mixins: [toastMixins],

    data() {
        return {
            modalOpen: false,
            loading: false,
            method: 'lost'
        }
    },

    methods: {
        openModal(method, id = false){
            this.method =  method || 'lost'
            this.modalOpen = !this.modalOpen

            if(id){
                this.$emit('setEditingDroplet', id)
            }
        },

        confirm() {
            this.loading = true

            let keyfob = _.find(this.record.keyfob, (x) => { return x.id == this.editingDroplet })

            // Set lost
            if (this.method === 'lost') {
                keyfob.isLost = true
            }
            if (this.method === 'found') {
                keyfob.isLost = false
            }

            axios.post(`/api/connect/broadcast`, {
                type: 'edit_droplet',
                id: this.editingDroplet,
                user: this.record.paxton_userid,
                organisation: this.organisationId,
                method: this.method,
                keyfob: _.find(this.record.keyfob, (x) => { return x.id == this.editingDroplet })
            }, {headers: {'Authorization': 'bearer ' + this.$store.state.authToken}}).then(() => {
                setTimeout(() => {
                    if(this.method == 'remove'){
                        this.$emit('deleteDroplet', keyfob)
                    } else {
                        this.$emit('updateDroplet', keyfob)
                    }
                }, 500)
            }).catch(() => {
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                this.$router.push({name: 'ConnectOverview'})
            })
        }
    }
}
</script>